import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Local Technician",
    body: "No call centers, no contractor roulette. You get a local owner-operator who knows Minneapolis streets — and treats your car like it's his own.",
  },
  {
    num: "02",
    title: "Upfront Price",
    body: "We quote a flat number before the van moves, and that's the number you pay. Most metro providers run $100–$150+ for the same calls.",
  },
  {
    num: "03",
    title: "No Surprise Fees",
    body: "Nights, weekends, holidays — $0 after-hours surcharge, always. And if you're in Zones 1–3, you'll never see a mileage fee either.",
  },
];

export const WhyUs = () => (
  <section id="why" data-testid="why-section" className="py-24 md:py-32 border-t border-white/10 bg-[#080808]">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal>
        <p className="eyebrow mb-4 text-center">03 — The Tru North Promise</p>
        <h2 className="font-display font-bold uppercase tracking-normal text-4xl sm:text-5xl lg:text-6xl max-w-3xl mx-auto leading-[1.02] text-center">
          <span className="block">Three things we will</span>
          <span className="block">never do to you.</span>
        </h2>
        <p className="mt-4 font-mono text-xs uppercase tracking-[0.25em] text-neutral-500 text-center">
          Hint: gouge, stall, or surprise you.
        </p>
      </Reveal>

      <div className="mt-16 border-b border-white/10">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.08}>
            <div className="grid md:grid-cols-[140px_1fr_1.2fr] gap-4 md:gap-10 py-10 border-t border-white/10 items-baseline">
              <span className="font-mono text-primary text-3xl md:text-4xl font-semibold">{c.num}</span>
              <h3 className="font-display font-semibold uppercase tracking-normal text-2xl md:text-3xl">{c.title}</h3>
              <p className="text-neutral-400 text-base leading-relaxed">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
